import React, { useState, useEffect } from "react";
import { Button, Genyses, Container, Section, ArrowsWrapper, Arrows, Scroll, Wrapper } from "./styles";

export const FAQ = () => {
    return(
        <Container>
            
        </Container>
    )
}